import { render, staticRenderFns } from "./buy-history.vue?vue&type=template&id=3445895e&scoped=true"
import script from "./buy-history.vue?vue&type=script&lang=ts"
export * from "./buy-history.vue?vue&type=script&lang=ts"
import style0 from "./buy-history.vue?vue&type=style&index=0&id=3445895e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445895e",
  null
  
)

export default component.exports